module.exports = __webpack_public_path__ + "fonts/KFOlCnqEu92Fr1MmYUtfBBc-.bcb7c7e2.woff";